module.exports = __webpack_public_path__ + "media/steps/dowod_rejestracyjny_bcg@2x-datafieldedit-4642ff61.png";